import { useLanguage, useSEO } from "../context/LanguageContext";
import { PageHero, Reveal, StatusBadge, Overline } from "../components/Kinetic";

const FeuilleDeRoutePage = () => {
  const { t } = useLanguage();
  useSEO(t("roadmap.metaTitle"), t("roadmap.metaDesc"));
  const phases = t("roadmap.phases");

  return (
    <div data-testid="roadmap-page">
      <PageHero
        overline={t("roadmap.overline")}
        titleLines={t("roadmap.titleLines")}
        intro={t("roadmap.intro")}
        testid="roadmap"
      />

      <section className="py-24 md:py-32">
        <div className="mx-auto max-w-6xl space-y-6 px-6">
          {phases.map((phase, i) => (
            <Reveal key={phase.num} delay={i * 0.06}>
              <article
                className={`grid gap-8 border p-8 transition-colors duration-300 md:grid-cols-3 md:p-12 ${
                  i === 0 ? "border-forest bg-forest-soft/40" : "border-graphite/10 bg-white hover:border-forest/40"
                }`}
                data-testid={`roadmap-phase-${i}`}
              >
                <div>
                  <p className="font-mono text-xs uppercase tracking-[0.25em] text-forest">{phase.num}</p>
                  <h2 className="mt-4 font-display text-3xl md:text-4xl font-light tracking-tight text-graphite">
                    {phase.title}
                  </h2>
                  <p className="mt-3 font-mono text-sm uppercase tracking-[0.15em] text-graphite-soft">{phase.period}</p>
                  <div className="mt-4">
                    <StatusBadge status={phase.status} />
                  </div>
                </div>
                <ul className="md:col-span-2">
                  {phase.items.map((item, j) => (
                    <li key={item} className="flex items-baseline gap-4 border-b border-graphite/10 py-3.5 last:border-0">
                      <span className="font-mono text-xs text-forest">{String(j + 1).padStart(2, "0")}</span>
                      <span className="text-sm md:text-base text-graphite">{item}</span>
                    </li>
                  ))}
                </ul>
              </article>
            </Reveal>
          ))}
          <Reveal>
            <div className="border-l-2 border-forest pl-6 pt-6">
              <Overline>{t("roadmap.overline")}</Overline>
              <p className="mt-3 max-w-3xl text-sm md:text-base leading-relaxed text-graphite-soft">{t("roadmap.note")}</p>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
};

export default FeuilleDeRoutePage;
